import React from 'react';

const Euro = () => (
	<svg viewBox="0 0 100 100" className="af-icon">
		<path className="euro" d="M60.5,44h-3.2c-0.8-3.6-3.3-5.9-6.9-5.9c-2,0-3.7,0.7-5,2c-1.4,1.4-1.8,2.9-2,5.9h9v2h-9v4h9v2h-9 c0.2,3.2,0.6,4.7,2,6.1c1.4,1.4,3.1,2,5,2c3.6,0,6.1-2.3,6.9-5.9h3.2c-1,5.4-4.9,8.7-10.1,8.7c-3,0-5.5-1.1-7.3-2.9 c-2.1-2.1-2.7-4.1-2.9-8h-2.7v-2h2.7v-4h-2.7v-2h2.7c0.2-3.8,0.8-5.7,2.9-7.8c1.8-1.8,4.3-2.9,7.3-2.9C55.7,35.4,59.5,38.6,60.5,44 z M48.4,74.1l-1.8,1.8l2.9,2.9C33.9,78.5,21.2,65.7,21.2,50c0-12.2,7.7-23.1,19.2-27.1l-0.8-2.4C27.1,24.9,18.8,36.8,18.8,50 c0,17.1,13.7,31,30.7,31.2l-2.9,2.9l1.8,1.8l5.9-5.9L48.4,74.1z M50.5,18.8l2.9-2.9l-1.8-1.8L45.7,20l5.9,5.9l1.8-1.8l-2.9-2.9 C66.1,21.5,78.8,34.3,78.8,50c0,12.2-7.7,23.1-19.2,27.1l0.8,2.4C72.9,75.1,81.2,63.2,81.2,50C81.2,32.9,67.5,19,50.5,18.8z"/>
	</svg>
);

export default Euro;



